import { CategoryCodes, isConsentGiven } from '@olxeu-eprivacy-storage/js';
import { getNinjaConfig } from './config/ninja';
import { Trackers } from './const';
import { isEprivacyStorageRequired } from './cookies/isEprivacyStorageRequired';

const REQUIRED_CATEGORIES_FOR_3RD_PARTY = [CategoryCodes.C0002, CategoryCodes.C0003];
export const trackersWithoutConsent = [Trackers.Hydra, Trackers.Braze];

/**
 * Checks for consent for specific tracker
 * @param {string} tracker
 */
export function hasRequiredConsentFor(tracker) {
  // when in native mode no tracking is allowed. The tracking is done by the native app
  if (getNinjaConfig().isNative) {
    return false;
  }
  // Hydra is always allowed
  if (!isEprivacyStorageRequired() || trackersWithoutConsent.includes(tracker)) {
    return true;
  }
  // 3rd party trackers need C0002 and C0003
  return REQUIRED_CATEGORIES_FOR_3RD_PARTY.every(isConsentGiven);
}
